import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func, string, bool } from 'prop-types';
import { translate } from 'react-i18next';

import {
  resetPassword,
  getErrorCode,
  getOpenStatus,
  resetPasswordComplete,
  resetPasswordInitialize,
  closeEditPanel,
} from '@dragonfruit/redux/resetPassword';

import styles from './AccountProfileResetPassword.scss';
import ResetPasswordForm from './components/ResetPasswordForm';

const mapStateToProps = state => ({
  errorCode: getErrorCode(state),
  openStatus: getOpenStatus(state),
});

class AccountProfileResetPassword extends Component {
  static propTypes = {
    closeEditPanel: func.isRequired,
    errorCode: string.isRequired,
    openStatus: bool.isRequired,
    resetPassword: func.isRequired,
    resetPasswordComplete: func.isRequired,
    resetPasswordInitialize: func.isRequired,
    t: func.isRequired,
  };

  componentWillUnmount() {
    this.props.closeEditPanel();
  }

  onToggleResetPassword = evt => {
    evt.preventDefault();
    const {
      openStatus,
      resetPasswordComplete,
      resetPasswordInitialize,
    } = this.props;

    if (openStatus) {
      resetPasswordComplete();

      return;
    }
    resetPasswordInitialize();

    return;
  };

  onResetPasswordSubmit = value => {
    const { confirmNewPassword, currentPassword, newPassword } = value;

    const { resetPassword } = this.props;

    resetPassword({
      confirmNewPassword,
      currentPassword,
      newPassword,
    });
  };

  render() {
    const { t, errorCode, openStatus } = this.props;

    return (
      <div className={styles.userFieldContainer}>
        <div className={styles.input}>
          <div className={styles.fieldContainer}>
            <p className={styles.field}>{t('account.password')}</p>
            <div className={styles.reset}>
              <p className={styles.value}>••••••••</p>
              {!openStatus && (
                <a
                  className={styles.linkButton}
                  onClick={this.onToggleResetPassword}
                >
                  <h6>{t('account.reset.text')}</h6>
                </a>
              )}
            </div>

            {openStatus && (
              <div className={styles.resetFormPadded}>
                <div className={styles.header}>
                  <p className={styles.field}>{t('account.resetPassword')}</p>
                  <a href="" onClick={this.onToggleResetPassword}>
                    {t('account.cancel')}
                  </a>
                </div>
                <ResetPasswordForm onSubmit={this.onResetPasswordSubmit} />
                {errorCode && <p className={styles.error}>{errorCode}</p>}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  resetPasswordComplete,
  resetPasswordInitialize,
  resetPassword,
  closeEditPanel,
})(translate('account')(AccountProfileResetPassword));



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileResetPassword/AccountProfileResetPassword.jsx